module.exports = __webpack_public_path__ + "static/media/celular-embaixo.22c69a5b.png";